import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import AppPage from "@/components/layout/AppPage.vue"
import { FAQ } from "../shared/constants"
import Icon from "../../widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Help',
  setup(__props) {

const faqs = computed(() => {
  return FAQ
})

return { __sfc: true,faqs, AppPage, Icon }
}

})